import { render } from "./Dashboard.vue?vue&type=template&id=cabea4ec&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=cabea4ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cabea4ec"

export default script